import React from 'react';
import { useTheme } from 'styled-components';

import houseDark from 'static/house-with-components.dark-mode.png';
import houseLight from 'static/house-with-components.light-mode.png';

export function HouseGraphic() {
  const theme = useTheme();

  return <img alt="house" src={theme.name === 'darkTheme' ? houseDark : houseLight} />;
}

export default HouseGraphic;
